import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { useCommunity } from "../../lib/community";
import "./community.css";

export function TgGlyph() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21.5 3.5 2.8 10.8c-.9.4-.9 1.6.1 1.9l4.6 1.5 1.8 5.6c.3.8 1.3 1 1.9.4l2.6-2.5 4.8 3.5c.7.5 1.6.1 1.8-.7l3-15.6c.2-1-.8-1.8-1.9-1.4Z" fill="currentColor" />
      <path d="m7.6 14.1 9.6-6.9-7.4 8.4" fill="none" stroke="#07120D" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  );
}

export const TgBadge = ({ size = 32 }) => <span className="gw-tg" style={{ width: size, height: size }}><TgGlyph /></span>;

export function useCommunityInfo() {
  const info = useCommunity((s) => s.info);
  useEffect(() => {
    const { load } = useCommunity.getState();
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  return info;
}

export function TgPill() {
  const info = useCommunity((s) => s.info);
  if (!info) return null;
  const { joined_label: j, online_label: o } = info;
  return (
    <a href={info.community_url} target="_blank" rel="noopener noreferrer" className="gw gw-pill shrink-0" data-testid="tg-header-pill" aria-label="Join the Greenwick Telegram community">
      <TgBadge size={28} />
      <span className="hidden sm:block">
        <span className="t1" data-testid="tg-header-joined">{j ? `${j} traders joined` : "Join the community"}</span>
        {o && <span className="t2" data-testid="tg-header-online"><span className="gw-live" />{o} online</span>}
      </span>
    </a>
  );
}

export function TgChip() {
  const info = useCommunity((s) => s.info);
  if (!info) return null;
  const parts = [info.joined_label && `${info.joined_label} joined`, info.online_label && `${info.online_label} online`].filter(Boolean);
  return (
    <a href={info.community_url} target="_blank" rel="noopener noreferrer" className="gw gw-chip ml-auto" data-testid="tg-status-chip">
      <TgGlyph /> {[...parts, "Join →"].join(" · ")}
    </a>
  );
}

function Feed({ items }) {
  if (!items?.length) return null;
  return (
    <div className="gw-msgs" data-testid="tg-widget-feed">
      {items.map((m) => (
        <div key={m.id} className={`gw-bub ${m.kind === "announcement" ? "" : "tr"}`} data-testid={`tg-feed-item-${m.kind}`}><small>{m.who}</small>{m.text}</div>
      ))}
    </div>
  );
}

export function TgWidget({ className = "", compact = false }) {
  const info = useCommunity((s) => s.info);
  if (!info) return null;
  const { joined_label: j, online_label: o } = info;
  return (
    <div className={`gw gw-ring ${className}`} data-testid="tg-widget">
      <div className="inn">
        <div className="flex items-center gap-2.5">
          <TgBadge size={34} />
          <div><b className="text-[14px] block">Greenwick on Telegram</b><span className="gw-mute text-[11px]">Community · trades shared live</span></div>
        </div>
        {(j || o) && (
          <div className="gw-stat2" style={{ gridTemplateColumns: j && o ? "1fr 1fr" : "1fr" }}>
            {j && <div><b className="gw-goldtext" data-testid="tg-widget-joined">{j}</b><small>traders joined</small></div>}
            {o && <div><b style={{ color: "var(--gw-green)" }} data-testid="tg-widget-online"><span className="gw-live" />{o}</b><small>online now</small></div>}
          </div>
        )}
        <Feed items={info.feed} />
        <div className="grid grid-cols-2 gap-1.5 mt-2.5">
          <a className="gw-btn" href={info.channel_url} target="_blank" rel="noopener noreferrer" data-testid="tg-widget-channel"><TgGlyph />Channel</a>
          <a className="gw-btn gh" href={info.community_url} target="_blank" rel="noopener noreferrer" data-testid="tg-widget-community"><MessageCircle />Community</a>
        </div>
      </div>
    </div>
  );
}

export function ShareRowButton({ onClick, testid }) {
  return (
    <button type="button" className="gw-shr" onClick={(e) => { e.stopPropagation(); onClick(); }} data-testid={testid}>
      <span style={{ display: "inline-flex", width: 12, height: 12 }}><TgGlyph /></span>Share
    </button>
  );
}
